import React from 'react';
import { useSound } from '../hooks/useSound';

interface NeonButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  color?: 'pink' | 'cyan' | 'yellow' | 'green';
  disabled?: boolean;
  className?: string;
  type?: 'button' | 'submit';
  sound?: string;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
}

export const NeonButton: React.FC<NeonButtonProps> = ({
  children,
  onClick,
  color = 'cyan',
  disabled = false,
  className = '',
  type = 'button',
  sound = 'click',
  onMouseEnter,
  onMouseLeave
}) => {
  const { playSound } = useSound();

  const handleClick = () => {
    if (!disabled) {
      playSound(sound);
      onClick?.();
    }
  };
  const colorClasses = {
    pink: 'bg-retro-purple text-white hover:shadow-neon-pink border-neon-pink',
    cyan: 'bg-retro-dark text-neon-cyan hover:shadow-neon-cyan border-neon-cyan',
    yellow: 'bg-retro-dark text-neon-yellow hover:shadow-neon-yellow border-neon-yellow',
    green: 'bg-retro-dark text-neon-green border-neon-green'
  };

  return (
    <button
      type={type}
      onClick={handleClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      disabled={disabled}
      className={`
        relative px-6 sm:px-8 py-3 sm:py-4 font-retro font-bold text-base sm:text-lg
        border-2 rounded-lg
        transition-all duration-300 transform
        hover:scale-105 active:scale-95
        ${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}
        ${colorClasses[color]}
        ${className}
      `}
    >
      <span className="relative z-10">{children}</span>
      {!disabled && (
        <div 
          className="absolute inset-0 opacity-50 rounded-lg animate-pulse-slow"
          style={{
            background: `linear-gradient(45deg, transparent, ${color === 'pink' ? '#ff1493' : color === 'yellow' ? '#ffff00' : '#00ffff'}, transparent)`
          }}
        />
      )}
    </button>
  );
};
